type Environment = "development" | "staging" | "production";

export interface DestinationConfig {
  schemaVersion: 1;
  environment: Environment;
  revision: string;
  enabled: boolean;
  name: string;
  destination: {
    mode: "embed" | "navigate";
    url: string;
    title: string;
    demo: boolean;
  };
}

export function parseDestination(
  value: unknown,
  context: { environment: Environment; origin: string },
): DestinationConfig {
  if (!value || typeof value !== "object")
    throw new Error("Invalid configuration.");
  const input = value as Record<string, unknown>;
  const target = input.destination as Record<string, unknown> | undefined;
  if (
    input.schemaVersion !== 1 ||
    input.environment !== context.environment ||
    typeof input.enabled !== "boolean" ||
    typeof input.name !== "string" ||
    !input.name.trim() ||
    typeof input.revision !== "string" ||
    !target ||
    !["embed", "navigate"].includes(String(target.mode)) ||
    typeof target.url !== "string" ||
    typeof target.title !== "string" ||
    typeof target.demo !== "boolean"
  )
    throw new Error("The configuration does not match this environment.");

  const url = new URL(target.url, context.origin);
  if (
    !["https:", "http:"].includes(url.protocol) ||
    (url.protocol !== "https:" && url.origin !== context.origin) ||
    url.username ||
    url.password
  )
    throw new Error("The video website must use a secure address.");
  if (
    url.origin === context.origin &&
    url.pathname.replace(/\/$/, "") !== "/preview/player"
  )
    throw new Error("The destination would open the launcher again.");
  if (
    context.environment === "production" &&
    (target.demo ||
      (url.origin === context.origin && url.pathname.startsWith("/preview/")))
  )
    throw new Error("Preview destinations are disabled in production.");

  return {
    schemaVersion: 1,
    environment: context.environment,
    revision: input.revision,
    enabled: input.enabled,
    name: input.name,
    destination: {
      mode: target.mode as "embed" | "navigate",
      url: url.href,
      title: target.title,
      demo: target.demo,
    },
  };
}
